import { supabase } from '../lib/supabase'
import type {
  CreateHomePopupPayload,
  HomePopup,
  UpdateHomePopupPayload,
} from '../types/homePopup'

export const homePopupService = {
  async list(): Promise<HomePopup[]> {
    const { data, error } = await supabase
      .from('home_popups')
      .select('*')
      .is('deleted_at', null)
      .order('starts_at', { ascending: false })

    if (error) throw error
    return data ?? []
  },

  async listActive(): Promise<HomePopup[]> {
    const now = new Date().toISOString()
    const { data, error } = await supabase
      .from('home_popups')
      .select('*')
      .is('deleted_at', null)
      .lte('starts_at', now)
      .gte('ends_at', now)
      .order('created_at', { ascending: false })

    // Tabela ainda não criada / sem permissão: home segue normalmente
    if (error) {
      console.error('homePopupService.listActive:', error.message)
      return []
    }
    return data ?? []
  },

  async create(payload: CreateHomePopupPayload): Promise<HomePopup> {
    const {
      data: { user },
    } = await supabase.auth.getUser()

    const { data, error } = await supabase
      .from('home_popups')
      .insert({
        title: payload.title.trim(),
        body: payload.body.trim(),
        starts_at: payload.starts_at,
        ends_at: payload.ends_at,
        created_by: user?.id ?? null,
      })
      .select('*')
      .single()

    if (error) throw error
    return data
  },

  async update(id: string, payload: UpdateHomePopupPayload): Promise<HomePopup> {
    const { data, error } = await supabase
      .from('home_popups')
      .update({
        title: payload.title.trim(),
        body: payload.body.trim(),
        starts_at: payload.starts_at,
        ends_at: payload.ends_at,
      })
      .eq('id', id)
      .is('deleted_at', null)
      .select('*')
      .single()

    if (error) throw error
    return data
  },

  async softDelete(id: string): Promise<void> {
    const { error } = await supabase
      .from('home_popups')
      .update({ deleted_at: new Date().toISOString() })
      .eq('id', id)
      .is('deleted_at', null)

    if (error) throw error
  },
}
